<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick" stretch="true" size="small">
      <el-tab-pane label="设备详情" name="first">
        <el-descriptions title="设备详情" direction="vertical" :column="2" border>
          <el-descriptions-item label="IMEI号">
            <el-tag>{{ imei }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="设备类型">
            <el-tag size="small">{{ deviceType }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="在线状态">
            <el-tag type="success" size="small" v-if="onlineFlag==='在线'">{{ onlineFlag }}</el-tag>
            <el-tag type="danger" size="small" v-if="onlineFlag==='掉线'">{{ onlineFlag }}</el-tag>
          </el-descriptions-item>
<!--          <el-descriptions-item label="创建时间" span="2">{{ createdTime }}</el-descriptions-item>-->
          <el-descriptions-item label="口径">
            <el-tag size="small">{{ caliber }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="设备地址">{{ userAdd }}</el-descriptions-item>
          <el-descriptions-item label="水表底数(m³)"> {{ maniFest }}</el-descriptions-item>
          <el-descriptions-item label="最近24小时用量(m³)"> {{ hourUsages }}</el-descriptions-item>
          <el-descriptions-item label="最近7日用水均值(m³)"> {{ sevenDayUsages }}</el-descriptions-item>
        </el-descriptions>
      </el-tab-pane>
      <el-tab-pane label="用量详情" name="second">
        <div class="block">
          <el-radio-group v-model="type" style="margin: 0 20px ">
            <el-radio label='0'>表格</el-radio>
            <el-radio label='1'>图表</el-radio>
          </el-radio-group>
          <el-button size="mini" type="primary" @click="handleQuery">查询</el-button>
        </div>
        <div style="margin: 10px 0;display: flex;align-items: center">
          <el-date-picker
            v-model="startDate"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="handleStart"
            placeholder="选择开始时间">
          </el-date-picker>
          <el-date-picker
            style="margin-left: 10px;"
            v-model="endDate"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="handleEnd"
            placeholder="选择结束时间">
          </el-date-picker>
        </div>
        <div>
          <el-radio-group v-model="dataType" style="margin: 0 20px ">
            <el-radio :label='0'>小时</el-radio>
            <el-radio :label='1'>天</el-radio>
            <el-radio :label='2'>月</el-radio>
          </el-radio-group>
        </div>
        <div style="margin-top: 20px;" v-if="type == 0">
          <el-table
            :data="tableData"
            style="width: 100%;text-align: center;"
            max-height="400"
            :border="true" :stripe="true" :highlight-current-row=true :show-summary="true">
            <el-table-column
              prop="date"
              label="项/名称"
              width="160">
            </el-table-column>
            <el-table-column
              prop="name"
              label="用量（m³）"
              width="160">
            </el-table-column>
          </el-table>
        </div>
        <div v-if="type == 1">
          <DosageECharts :data-history="dataHistory" :date-history="dateHistory"/>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import axios from "axios";
import DosageECharts from "./Dosage-ECharts.vue";

export default {
  name: 'Home',
  components: {DosageECharts},
  data() {
    return {
      startDate: "",
      endDate: "",
      imei: '',
      deviceType: '',
      userAdd: '',
      createdTime: '',
      onlineFlag: '',
      caliber: '',
      maniFest: '',
      hourUsages: '',
      sevenDayUsages: '',
      deviceData: [],
      dateHistory: [],
      dataHistory: [],
      tableData: [],
      deviceName: "",
      activeName: "first",
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一天',
            onClick(picker) {
              const end = new Date().setHours(23, 59, 0o0);
              const start = new Date().setHours(0o0, 0o0, 0o0);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
      },
      dateTime: [new Date().setHours(0o0, 0o0, 0o0), new Date().setHours(23, 59, 0o0)],
      dataType: 1,
      type: '0'
    };
  },
  watch: {
    "dataType": {
      handler(val) {
        let obj = {
          imei: this.$route.query.imei,
          dateType: val,
          startDate: this.startDate,
          endDate: this.endDate
        }
        // console.log(this.startDate, this.endDate);
        this.getData(obj);
      },
      immediate: true
    }
  },
  methods: {
    handleClick(tab, event) {
      if (tab.paneName == "second") {
        let param = {
          imei: this.$route.query.imei,
          dateType: 1,
        }
        // this.getData(param);
      }
    },
    getData(param) {
      axios.post('/api/demo/nbllhisdata/yun/getHistoryDataList', param).then((res) => {
        this.deviceName = res.data.data.nbDeviceEntity[0].userName
        this.deviceData = res.data.data.nbDeviceEntity
        this.dateHistory = res.data.data.historyDataEcharts.dateLists
        this.dataHistory = res.data.data.historyDataEcharts.dataLists
        this.tableData = res.data.data.analysisData
      })
    },
    initData() {
      const imei = this.$route.query.imei
      axios.get("/api/demo/nbdevice/yun/" + imei).then((res => {
        this.imei = res.data.data.imei
        this.deviceType = res.data.data.deviceType
        this.userAdd = res.data.data.userAdd
        this.createdTime = res.data.data.createdTime
        this.onlineFlag = res.data.data.onlineFlag
        this.caliber = res.data.data.caliber
        this.maniFest = res.data.data.maniFest
        this.hourUsages = res.data.data.hourUsages
        this.sevenDayUsages = res.data.data.sevenDayUsages
      }))
    },
    // 选择开始时间
    handleStart(date) {
      const params = {
        dateType: this.dataType,
        startDate: date,
        endDate: this.endDate
      }
      // this.getData(params)
    },
    // 选择结束时间
    handleEnd(date) {
      const params = {
        dateType: this.dataType,
        startDate: this.startDate,
        endDate: date
      }
      // this.getData(params)
    },
    // 查询
    handleQuery() {
      console.log(this.startDate,this.endDate,this.dataType)
      const params = {
        imei: this.$route.query.imei,
        dateType: this.dataType,
        startDate: this.startDate,
        endDate: this.endDate
      }
      this.getData(params)
    }
  },
  mounted() {
    this.initData()
  },
}
</script>

<style scoped>
/deep/.has-time {
  left: 0;
}
/deep/ .el-descriptions-item__cell{
  text-align: center !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue